import { v4 as uuid } from 'uuid';

export const footerData = [
    {
        _id: uuid(),
        dataHeading: "Get to Know Us",
        dataLinks: [
            "Link 1",
            "Link 2",
            "Link 3",
            "Link 4",
            "Link 5",
            "Link 6",
        ]
    },

    {
        _id: uuid(),
        dataHeading: "Connect With Us",
        dataLinks: [
            "Link 1",
            "Link 2",
            "Link 3",
        ]
    },

    {
        _id: uuid(),
        dataHeading: "Grow With Us",
        dataLinks: [
            "Link 1",
            "Link 2",
            "Link 3",
            "Link 4",
        ]
    },

    {
        _id: uuid(),
        dataHeading: "Let Us Help You",
        dataLinks: [
            "Link 1",
            "Link 2",
            "Link 3",
            "Link 4",
            "Link 5",
            "Link 6",
        ]
    }

]